import { render, staticRenderFns } from "./otherInStock.vue?vue&type=template&id=572147a2&scoped=true&"
import script from "./otherInStock.vue?vue&type=script&lang=js&"
export * from "./otherInStock.vue?vue&type=script&lang=js&"
import style0 from "./otherInStock.vue?vue&type=style&index=0&id=572147a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572147a2",
  null
  
)

export default component.exports